import Model from './Model';

export default abstract class ModelMarshaller<T extends Model> {

    protected data: any | T;

    constructor(data : T|any) {
        this.data = data;
    }

    abstract toJSON() : any;
    abstract toModel() : T;
}